import React, { useState } from 'react';
import { EditIcon, TrashIcon,VerticalDotsIcon,ApplicationIcon } from '../../assets';
import { useNavigate } from 'react-router-dom';
import {useDispatch} from "react-redux";
import { Outlet_Delete } from '../../action/outletAction';
import { offer_del } from '../../action/offerAction';

const OfferTableActions = (data) => {
    const [activeRow, setActiveRow] = useState(data.data);
    const [actions, setActions] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();


    const ACTIONS = [
        {
            icon: EditIcon,
            title: 'Edit',
            action: () => navigate(`/offers/edit/`+data.data)
        },
        {
            icon: ApplicationIcon,
            title: 'View Offers',
            action: () => console.log('View Card Clicked of', activeRow)
        },
        {
            icon: TrashIcon,
            title: 'Delete',
            action: () => OfferDelete(data.data)
        }
    ];

  

    const OfferDelete = async(id) =>{
        console.log("in",id);
        var dtl ={
            'Id':id
        }
        var cat = await dispatch(offer_del(dtl));
        if (cat.success) {
           window.location.reload();
        }
    }


    return  <div className="pl-3 relative">
    <button  className="py-3"
        onMouseEnter={() => setActions(true)}
        onMouseLeave={() => setActions(false)}>
        <VerticalDotsIcon />
        {actions && (
            <div className="items-start top-8 -left-16 flex py-2 w-36 flex-col absolute bg-white z-40 shadow-xl border rounded-lg border-kb-light-gray text-kb-dark-gray">
                {ACTIONS.map((item) => (
                    <button
                        key={item.title}
                        className="px-4 py-2 w-full rounded-md flex gap-3 items-center hover:bg-kb-light-blue hover:text-kb-light-blue hover:bg-opacity-20"
                        onClick={item.action}
                    >
                        <item.icon />
                        <span >{item.title}</span>
                    </button>
                ))}
            </div>
        )}
    </button>
</div>;
};

export default OfferTableActions;
